export default {
  mai_mult_label: 'More',
  mai_incarca_label: 'Try again',
  publicat_label: 'Published at'
}
